import { ADVANCEPAY as NAME } from '../../constants';
export {MENU_CODE} from'../../constants';
export { DMS_MODULE, ADVANCEPAY as NAME } from '../../constants';
export const DEPENDENT_TABLES = <const>[NAME];
export const ADVANCE_PAYMENT_ID = null;
export const TAB_ACCESS_CODE='cmdAdvancePay_read_write'
export enum DefaultCurrency {
	PrimaryText = 'NTD',
	SecondaryText = 'TWD'
}
export enum EGUI_OPTIONS {
	EGUI_ISSUE = 'issueInvoice',
	EGUI_PRINT = 'printInvoice',
	EGUI_CANCEL = 'cancelInvoice',
	EGUI_RTN_CODE = 7
}
export enum EGUI_TRANS_OPTIONS {
	SEPERATE = 1,
	COMBINE = 2
}
export enum EGUI_TYPES {
	COMPANY = 1,
	WITH_CARRIER = 2,
	NO_CARRIER = 3
}

